'use client';

import { usePathname } from 'next/navigation';

export function StructuredBreadcrumb() {
  const pathname = usePathname();

  // Don't render on the home page or if pathname is unavailable
  if (!pathname || pathname === '/') return null;

  const siteUrl = 'https://www.zumify.co';

  // Split pathname into segments, remove empty strings
  const segments = pathname.split('/').filter((v) => v.length > 0);

  // Helper to format segment names (capitalize and replace dashes with spaces)
  const formatName = (str: string) => {
    return str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const breadcrumbList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: siteUrl,
      },
      ...segments.map((segment, index) => {
        const urlPath = `/${segments.slice(0, index + 1).join('/')}`;
        return {
          '@type': 'ListItem',
          position: index + 2,
          name: formatName(segment),
          item: `${siteUrl}${urlPath}`,
        };
      }),
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbList) }}
    />
  );
}
